export const BannerConfig = {
  all: {
    title: 'products.banner.all.title1',
    description: 'products.banner.all.description1',
    bgrDesktop: '/s2/raster/wfc-banner-assets-dt.png',
    bgrMobile: '/s2/raster/wfc-banner-assets-mobile.png',
    color: 'blue',
  },
  'meet-legal-requirements': [
    {
      title: 'products.banner.meetLegalRequirements.title1',
      description: 'products.banner.meetLegalRequirements.description1',
      logo: '/s2/raster/worry-free-compliance.png',
      bgrDesktop: '/s2/raster/wfc-banner-assets-dt.png',
      bgrMobile: '/s2/raster/wfc-banner-assets-mobile.png',
      color: 'blue',
    },
    {
      title: 'products.banner.meetLegalRequirements.title2',
      description: 'products.banner.meetLegalRequirements.description2',
      logo: '',
      bgrDesktop: '/s2/raster/trademk-banner-assets-dt.png',
      bgrMobile: '/s2/raster/trademk-banner-assets-mobile.png',
      color: 'green',
    },
    {
      title: 'products.banner.meetLegalRequirements.title3',
      description: 'products.banner.meetLegalRequirements.description3',
      logo: '/s2/raster/biz-doc-template-library.png',
      bgrDesktop: '/s2/raster/business-doc-banner-assets-dt.png',
      bgrMobile: '/s2/raster/business-doc-banner-assets-mobile.png',
      color: 'green',
    },
    {
      title: 'products.banner.meetLegalRequirements.title4',
      description: 'products.banner.meetLegalRequirements.description4',
      logo: '/s2/raster/biz-license-report.png',
      bgrDesktop: '/s2/raster//blr-banner-assets-dt.png',
      bgrMobile: '/s2/raster//blr-banner-assets-mobile.png',
      color: 'blue',
    },
  ],
  'manage-your-money': {
    title: 'products.banner.manageYourMoney.title1',
    description: 'products.banner.manageYourMoney.description1',
    logo: '/s2/raster/money-pro.png',
    bgrDesktop: '/s2/raster/banner-dashboard-moneypro-dt.png',
    bgrMobile: '/s2/raster/banner-dashboard-moneypro-mobile.png',
    color: 'green',
  },
  'find-customers-online': {
    title: 'products.banner.findCustomersOnline.title1',
    description: 'products.banner.findCustomersOnline.description1',
    logo: '/s2/raster/business-website.png',
    bgrDesktop: '/s2/raster/web-banner-assets-dt.png',
    bgrMobile: '/s2/raster/web-banner-assets-mobile.png',
    color: 'blue',
  },
};
